import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'

import {Home} from '../pages/home/Home'
import {SharedFolder} from '../pages/sharedFolder/SharedFolder'
import {File} from '../pages/file/File'
import { SharedFile } from '../pages/file/SharedFile'
// import { UserManage } from '../pages/userManage/UserManage'
// import {Template} from '../pages/template/Template'
// import {SingleParamCSV} from '../pages/template/component/SingleParamCSV'
// import {MultiParamCSV} from '../pages/template/component/MultiParamCSV'
// import {STDMultiParamRep} from '../pages/template/component/STDMultiParamRep'

const PrivateRoutes = () => {
  
  // template lazy module
  const Template = lazy(() => import('../pages/template/Template'))
  const SingleParamCSV = lazy(() => import('../pages/template/component/SingleParamCSV'))
  const MultiParamCSV = lazy(() => import('../pages/template/component/MultiParamCSV'))
  const STDMultiParamRep = lazy(() => import('../pages/template/component/STDMultiParamRep'))

  // user manage lazy module
  const UserManage = lazy(() => import('../pages/userManage/UserManage'))

  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/home' />} />
        {/* Pages */}
        <Route path='home' element={<Home />} />
        <Route path='sharedFolder' element={<SharedFolder />} />
        {/* <Route path='userManage' element={<UserManage />} /> */}
        <Route path='file/:id' element={<File />} />
        <Route path='sharedfile/:id' element={<SharedFile />} />
        {/* <Route path='home/template' element={<Template />} /> */}
        {/* template components */}
        {/* <Route path='home/template/singleparamcsv' element={<SingleParamCSV />} /> */}
        {/* <Route path='home/template/multiparamcsv' element={<MultiParamCSV />} /> */}
        {/* <Route path='home/template/std_mulparam_rep' element={<STDMultiParamRep />} /> */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='userManage'
          element={
            <SuspensedView>
              <UserManage />
            </SuspensedView>
          }
        />
        <Route
          path='home/template'
          element={
            <SuspensedView>
              <Template />
            </SuspensedView>
          }
        />
        <Route
          path='home/template/singleparamcsv'
          element={
            <SuspensedView>
              <SingleParamCSV />
            </SuspensedView>
          }
        />
        <Route
          path='home/template/multiparamcsv'
          element={
            <SuspensedView>
              <MultiParamCSV />
            </SuspensedView>
          }
        />
        <Route
          path='home/template/std_mulparam_rep'
          element={
            <SuspensedView>
              <STDMultiParamRep />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
